const MultilineHelperText = ({texts}) => (
  <>{texts.map(m => <span key={m}>{texts.length > 1 ? `• ${m}` : m}<br/></span>)}</>
);

export default MultilineHelperText